<div class="basis-full flex flex-row mb-3 rounded-t-md">
  <div class="grow flex flex-row">
    <div class="text-[1.125rem] font-medium">{{title()}}</div>
  </div>
  <div class="">
    <p-dropdown
      [styleClass]="'sort'"
      appendTo="body"
      optionLabel="label"
      [options]="sortOptions"
      [ngModel]="sortModel()"
      (onChange)="onSortChange($any($event).value)"
      [showClear]="false">
    </p-dropdown>

    @if (!commentsOnly()) {
      <p-dropdown
        class="ml-2"
        [styleClass]="'sort'"
        appendTo="body"
        optionLabel="label"
        [options]="filterOptions"
        [ngModel]="filterModel()"
        (onChange)="onFilterChange($any($event).value)"
        [showClear]="false">
      </p-dropdown>
    }
  </div>
</div>

<div class="activity-stream">
  <div class="text-[14px] pt-2 pb-2">
    <ul class="activities-list relative">
      @for (activity of activities(); track activity.id; let i = $index, isFirst = $first, isLast = $last) {
      <li app-activity-renderer class="activity pb-6 last:pb-0 w-full"
        (reloaded)="reload()"
        [activity]="activity"
        [ownerId]="owner()?.id"
        [index]="i"
        [isFirst]="isFirst"
        [isLast]="isLast">
      </li>
      }
    </ul>

    @if (showPagination()) {
      <div class="flex justify-end items-center mt-2 mb-4">
        <nx-default-button
          [style]="'dark'"
          class="ml-2"
          (click)="previousPage()"
          [disabled]="!hasPreviousPage()"
          [icon]="'icon-previous'">
        </nx-default-button>
        <nx-default-button
          [style]="'dark'"
          class="ml-2"
          (click)="nextPage()"
          [disabled]="!hasNextPage()"
          [icon]="'icon-next'">
        </nx-default-button>
      </div>
    }

    <div class="addComment" [ngClass]="activities().length > 0 ? 'mt-4' : ''">
      <nx-activity-comment-created-create-command
        [owner]="owner()"
        (reloaded)="reload()">
      </nx-activity-comment-created-create-command>
    </div>
  </div>
</div>
